export const POST_FEED_PER_PAGE = 20;
